import { api } from "@/lib/api";

import type {
  CreateUnitOfMeasurementReq,
  UnitOfMeasurement,
  UnitOfMeasurementList,
  UpdateUnitOfMeasurementReq,
  UomUsageSummary,
} from "@artisancode/api-types";

export interface UomListParams {
  page?: number;
  per_page?: number;
  q?: string;
  category?: string;
  is_active?: boolean;
  workspace_id?: string;
}

export const uomService = {
  list: (params?: UomListParams) =>
    api.get<UnitOfMeasurementList>(
      "/uoms",
      params as Record<string, string | number | boolean | undefined>,
    ),

  create: (body: CreateUnitOfMeasurementReq) =>
    api.post<UnitOfMeasurement>("/uoms", body),

  update: (id: string, body: UpdateUnitOfMeasurementReq) =>
    api.put<UnitOfMeasurement>(`/uoms/${id}`, body),

  delete: (id: string) => api.del<{ message: string }>(`/uoms/${id}`),

  usage: (id: string) => api.get<UomUsageSummary>(`/uoms/${id}/usage`),
};
